export const stablecoinIds = [1, 2, 3, 5, 7, 11, 14, 15, 16, 19];
